const RiskIndicator = require('okCharts/RiskIndicator');

module.exports = RiskIndicator;
